import React from "react";
import { CheckBox } from "react-native-web";

export default CheckBox;
